module.exports = __webpack_public_path__ + "img/emoji_104.4e644114.png";